export default "__VITE_ASSET__jp3w$9mr__"